<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 37 37">
      <g id="Group_2505" data-name="Group 2505" transform="translate(-271 -13)">
        <circle id="Ellipse_61" data-name="Ellipse 61" cx="19" cy="19" r="17.5" transform="translate(271 13)" fill="rgba(255,255,255,0.17)" class="spacesearch"  stroke="none" />
        <path id="Search" d="M12.792,9a6.767,6.767,0,1,0,3.883,12.317L20.5,25.142a1.475,1.475,0,0,0,1.593-.116c.639-.615.075-1.551.075-1.551L18.322,19.63A6.762,6.762,0,0,0,12.792,9Zm0,11.18A4.413,4.413,0,1,1,17.2,15.767a4.413,4.413,0,0,1-4.413,4.413Z" transform="translate(275.284 14.333)"  fill="#fff" class="fillblackwhite"  />
      </g>
    </svg>
    </template>
    <script>
    
     export default{
       name :"SearchMobile",
     }
    </script>
    <style lang="scss">
      @import "@/sass/_variables.scss";
      @import "@/sass/_components.scss";
    
      .smallfill{
        fill:$clr-smallsearchfill
      }
      .spacesearch{
        fill:$clr-expand-search
      }
      .fillblackwhite{
        fill:$clr-saina-topnav-btn
      }
    </style>
    